<template>
  <highcharts ref="PotsChart" :options="chartOptions"></highcharts>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";

export default defineComponent({
  name: "PotsChart",
  components: {
    highcharts: Chart
  },
  setup() {
    const PotsChart = ref(null);

    return {
      PotsChart
    };
  },
  updated() {
    this.PotsChart.chart.reflow();
  },
  computed: {
    getPotsChartData() {
      return this.$store.state.potsChartData;
    },
    chartOptions() {
      return {
        chart: {
          backgroundColor: "white",
          borderColor: "lightgray",
          borderWidth: 0,
          borderRadius: 0,
          zoomType: "x",
          panning: true,
          panKey: "shift",
          type: "column",
          height: 380
        },
        title: {
          text: "Pot Value (end of each year)",
          style: {
            color: "#5c5b5b",
            fontWeight: "600",
            fontSize: "13px"
          }
        },
        xAxis: {
          title: {
            text: "End of Retirement Year",
            style: {
              color: "#5c5b5b",
              fontSize: "12px"
            }
          },
          allowDecimals: false,
          tickInterval: 1,
          tickLength: 0
        },
        yAxis: {
          title: {
            text: "",
            rotation: 0,
            style: {
              color: "Black",
              fontWeight: "500",
              fontSize: "14px"
            }
          },
          labels: {
            formatter: function() {
              return (
                "£" +
                Highcharts.numberFormat(this.value / 1000, 0, ".", ",") +
                "k"
              );
            }
          },
          stackLabels: {
            enabled: false,
            style: {
              fontWeight: "bold",
              color: "gray"
            }
          }
        },
        legend: {
          verticalAlign: "bottom",
          floating: false,
          backgroundColor: "white",
          borderColor: "LightGray",
          borderWidth: 0,
          borderRadius: 5,
          shadow: false,
          itemStyle: {
            color: "Grey",
            fontWeight: "lighter",
            fontSize: "12px"
          }
        },
        tooltip: {
          backgroundColor: "white",
          borderWidth: 1,
          borderRadius: 3,
          shadow: false,
          formatter: function() {
            return (
              "<b>" +
              "Retirement Year " +
              this.x +
              "</b><br/>" +
              this.series.name +
              ": " +
              "\u00A3" +
              Highcharts.numberFormat(this.y, 0, ".", ",") +
              "<br/>" +
              "Total at end of year: " +
              "\u00A3" +
              Highcharts.numberFormat(this.point.stackTotal, 0, ".", ",")
            );
          }
        },
        plotOptions: {
          column: {
            pointPadding: -0.1,
            borderWidth: 1,
            shadow: false,
            borderRadius: 0,
            stacking: "normal",
            dataLabels: {
              enabled: false,
              color: "black"
            },
            pointStart: 1
          }
        },
        series: this.getPotsChartData,
        exporting: {
          enabled: false
        }
      };
    }
  }
});
</script>

<style>
.highcharts-container {
  width: 100% !important;
}
</style>
